export default {
  description: '{{name}} în {{city}}. Meniu oficial. Economisește bani și comandă online.',
};
